import React from "react";
import { Table, Rate } from "antd";
import { useSelector } from "react-redux";
import MyMenuSurveyTableCommentModal from "./MyMenuSurveyTableCommentModal";

const MyMenuSurveyTable = () => {
  const { surveyReport, loading } = useSelector(
    (state) => state.myMenuSurveyReducer
  );

  const uniqueValues = (key) =>
    [...new Set(surveyReport.map((item) => item[key]))].map((val) => ({
      text: val,
      value: val,
    }));

  const columns = [
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
      width: "13%",
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Сметка",
      dataIndex: "billId",
      key: "billId",
      width: "5%",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Сервитьор",
      dataIndex: "waiterName",
      key: "waiterName",
      width: "10%",
      filters: uniqueValues("waiterName"),
      onFilter: (value, record) => record.waiterName === value,
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Обслужване",
      dataIndex: "serviceRating",
      key: "serviceRating",
      width: "10%",
      filters: [1, 2, 3, 4, 5].map((num) => ({
        text: `${num} звезди`,
        value: num,
      })),
      onFilter: (value, record) => record.serviceRating === value,
      render: (stars) => (
        <Rate
          disabled
          defaultValue={stars}
          className="my-meny-survey-small-stars"
        />
      ),
    },
    {
      title: "Продукт 1",
      dataIndex: "productOneName",
      key: "productOneName",
      width: "10%",
      filters: uniqueValues("productOneName"),
      filterSearch: true,
      onFilter: (value, record) => record.productOneName === value,
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Оценка 1",
      dataIndex: "productOneRating",
      key: "productOneRating",
      filters: [1, 2, 3, 4, 5].map((num) => ({
        text: `${num} звезди`,
        value: num,
      })),
      width: "10%",
      onFilter: (value, record) => record.productOneRating === value,
      render: (stars) => (
        <Rate
          disabled
          defaultValue={stars}
          className="my-meny-survey-small-stars"
        />
      ),
    },
    {
      title: "Продукт 2",
      dataIndex: "productTwoName",
      key: "productTwoName",
      width: "10%",
      filters: uniqueValues("productTwoName"),
      filterSearch: true,
      onFilter: (value, record) => record.productTwoName === value,
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Оценка 2",
      dataIndex: "productTwoRating",
      key: "productTwoRating",
      filters: [1, 2, 3, 4, 5].map((num) => ({
        text: `${num} звезди`,
        value: num,
      })),
      width: "10%",
      onFilter: (value, record) => record.productTwoRating === value,
      render: (stars) => (
        <Rate
          disabled
          defaultValue={stars}
          className="my-meny-survey-small-stars"
        />
      ),
    },
    {
      title: "Препоръка",
      dataIndex: "recommendFriend",
      key: "recommendFriend",
      width: "5%",
      filters: [
        { text: "Да", value: true },
        { text: "Не", value: false },
      ],
      onFilter: (value, record) => record.recommendFriend === value,
      render: (val) => (val ? "Да" : "Не"),
    },
    {
      title: "Коментар",
      dataIndex: "optionalComment",
      key: "optionalComment",
      width: "17%",
      // render: (text) => <span>{text || "-"}</span>,
      render: (text) => <MyMenuSurveyTableCommentModal comment={text} />,
    },
  ];

  return (
    <div className="mymenu-survey-table-container">
      <Table
        columns={columns}
        dataSource={surveyReport}
        rowKey={(record) => `${record.billId}-${record.date}`}
        loading={loading}
        size="small"
        className="mymenu-survey-table"
      />
    </div>
  );
};

export default MyMenuSurveyTable;
